<template>
  <v-card>
    <v-card-title class="justify-center">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn color="primary" @click="newItem()">Nuevo Usuario</v-btn>
        </v-col>
        <!--
        <v-col cols="12" class="text-center">
          <v-btn color="primary" dark class="mb-2" @click="downloadExport()">
            <v-icon left>
              mdi-download
            </v-icon>
            Descargar
          </v-btn>
        </v-col>
        -->
      </v-row>
      <UsuarioAgregar
        v-if="dialog"
        @saved="fetchData()"
        @dialogChange="dialogChange"
        :dialog="dialog"
        :dato="dato"
      />
    </v-card-title>
    <v-data-table :headers="headers" :items="datos" hide-default-footer>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"
          >mdi-information</v-icon
        >
      </template>
    </v-data-table>

    <v-pagination
      v-model="page"
      :length="pages"
      v-on:input="fetchData()"
    ></v-pagination>
  </v-card>
</template>

<script>
//import axios from "axios";
import UsuarioAgregar from "@/components/UsuarioAgregar.vue";
import RemisoriaService from "@/api/remisoria/RemisoriaService";
import UserService from "@/api/UserService";
import moment from "moment";

export default {
  components: {
    UsuarioAgregar
  },
  data() {
    return {
      dato: {},
      dialog: false,
      url: process.env.VUE_APP_API,
      page: 1,
      pages: 1,
      datos: [],
      search: "",
      headers: [
        { text: "#", align: "start", value: "id" },
        { text: "Nombre Completo", value: "getFullNameDisplay" },
        { text: "Usuario", value: "username" },
        //{ text: "nombre", value: "name" },
        { text: "Rol", value: "role.name" },
        { text: "Acción", value: "actions", sortable: false }
      ]
    };
  },
  methods: {
    setDefaultItem() {
      const newDto = {
        username: "",
        password: "",
        firstname: "",
        lastname: "",
        role: ""
      };
      this.dato = newDto;
    },
    dialogChange(value) {
      this.dialog = value;
    },
    editItem(item) {
      this.dato = { ...item };
      this.dialogChange(true);
    },
    newItem() {
      this.setDefaultItem();
      this.dialogChange(true);
    },
    buscar() {
      this.search = this.filtro;
      //this.fetchData();
    },
    fetchData() {
      console.log("llamando api");
      //axios.get("data/datos.json").then(response => {
      /*
      axios
        .get(
          this.url +
            "/remisoria-base/paginado?page=" +
            this.page +
            "&limit=10" +
            "&search=" +
            this.search
        )
        */
      UserService.getUsers().then(response => {
        //this.datos = response.data?.items || [];
        this.datos = response;
        this.pages = response.data?.meta?.totalPages || 0;
      });
    },
    downloadExport() {
      RemisoriaService.getRemisoriasExcel()
        .then(response => {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([response.data]));
          const today = new Date();
          moment.locale("es");
          link.setAttribute(
            "download",
            `remisoria-_${moment(today).format("YYYY-MMMM-DD")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          console.log("no se pudo generar el documento");
        });
    }

    //nuevo
  },
  created() {
    this.fetchData();
  }
};
</script>
